import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=e9c7fc2e&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=e9c7fc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c7fc2e",
  null
  
)

export default component.exports